import "index.css";
import reportWebVitals from "reportWebVitals";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Editor from "routes/editor/Editor";
import SuccessRegister from "routes/success-register/SuccessRegister";
import SuccessResetPassword from "routes/success-reset-password/SuccessResetPassword";
import SuccessSetupPassword from "routes/success-setup-password/SuccessSetupPassword";
import Login from "routes/login/Login";
import ResetPassword from "routes/reset-password/ResetPassword";
import SetupPassword from "routes/setup-password/SetupPassword";
import TwoFactorAuthentication from "routes/two-factor-authentication/TwoFactorAuthentication";
import URLErrorMessage from "routes/url-error/URLErrorMessage";
import MainView from "routes/main-view/MainView";
import Quiz from "routes/quiz/Quiz";
import RouteError from "routes/route-error/RouteError";
import {
  PlatformProvider,
  usePlatform,
} from "components/utils/PlatformContext";
import { HelmetProvider, Helmet } from "react-helmet-async";
import RootLayout from "routes/RootLayout";

const router = createBrowserRouter([
  {
    path: "*",
    element: <RouteError />,
  },
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: "/home",
        element: <MainView />,
      },
      {
        path: "/editor/:moduleOrProject/:id",
        element: <Editor />,
      },
      {
        path: "/quiz/:quizId",
        element: <Quiz />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
      {
        path: "setup-password",
        children: [
          {
            path: ":resetTokenId",
            element: <SetupPassword />,
          },
        ],
      },
      {
        path: "success-register",
        element: <SuccessRegister />,
      },
      {
        path: "success-reset-password",
        element: <SuccessResetPassword />,
      },
      {
        path: "success-setup-password",
        element: <SuccessSetupPassword />,
      },
      {
        path: "two-factor-authentication",
        element: <TwoFactorAuthentication />,
        children: [
          { path: ":twoFactorId", element: <TwoFactorAuthentication /> },
        ],
      },
      {
        path: "url-error",
        element: <URLErrorMessage text="page" />,
      },
    ],
  },
]);

const App = () => {
  // Get the platform context values
  const { title, favicon } = usePlatform();

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={`${title} App`} />
        <link rel="icon" href={favicon} />
        <link rel="apple-touch-icon" href={favicon} />
      </Helmet>
      <RouterProvider router={router} />
    </>
  );
};

createRoot(document.getElementById("root") as HTMLElement).render(
  <HelmetProvider>
    <PlatformProvider>
      <App />
    </PlatformProvider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
